import { useMemo } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { END } from "redux-saga";
import { useSelector } from "react-redux";

import SpaceDetails from "../../src/ourSpace/SpaceDetails";
import Notfound from "../404";

import { wrapper } from "../../src/config/Store";
import { getAllCMS } from "../../src/redux/cms/CMSActions";
import Routes from "../../src/routes/Routes";
import constants from "../../src/utils/Constants";

const { CMS_TYPES } = constants;

const OurSpaceDetails = () => {
  const router = useRouter();
  const { spaceName } = router.query;

  const mPageDetails = useSelector(({ cms }) => cms.cmsMap[spaceName]);
  const pageMeta = useMemo(() => mPageDetails?.meta?.pageMeta, [mPageDetails]);

  if (!mPageDetails) {
    return <Notfound />;
  }

  return (
    <>
      <Head>
        <title>{pageMeta?.title}</title>
        <meta name="description" content={pageMeta?.description} />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link
          rel="canonical"
          href={`${Routes?.domain}${Routes?.availability}/${spaceName}`}
        />
      </Head>

      <SpaceDetails />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const { spaceName } = context.params;
    const cmsState = store.getState().cms;

    const spaceDetailsParams = { _id: spaceName };
    const spaceDetailsBoard =
      cmsState.boards[JSON.stringify(spaceDetailsParams)];

    if (!spaceDetailsBoard) {
      store.dispatch(getAllCMS(spaceDetailsParams));
    }

    const ourSpaceFoldsParams = {
      type: CMS_TYPES.PAGE_FOLD,
      page_name: spaceName,
    };
    const ourSpaceFoldsBoard =
      cmsState.boards[JSON.stringify(ourSpaceFoldsParams)];
    if (!ourSpaceFoldsBoard) {
      store.dispatch(getAllCMS(ourSpaceFoldsParams));
    }

    store.dispatch(END);
    await store.sagaTask.toPromise();
  }
);

export default OurSpaceDetails;
